import { ActivityType } from "PFApp/components/card_tx/header/activity_type_badge";
import { Card } from "PFComponents/card";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { Activity } from "PFTypes";

import { CardTxContent } from "./card_tx_content";

export type CardTxProps = {
  task: Activity;
  numberOfRoles?: number;
  isHotVisible?: boolean;
  isFeed?: boolean;
  handleEditPost?: (taskId: number) => void;
  handleHeaderClick?: () => void;
  onShare?: (id: number) => void;
  handleRefetchActivities?: () => void;
};

export const CardTx = ({
  task,
  numberOfRoles,
  isHotVisible,
  isFeed,
  handleEditPost,
  handleHeaderClick,
  onShare,
  handleRefetchActivities
}: CardTxProps) => {
  const {
    data: { templates }
  } = useMyAccountInfo();

  const type: ActivityType = (templates || []).find(({ id }) => id === task.template_id) || {
    key: "default"
  };

  const isDraft = task.state === "draft";
  const canShare = task.state !== "draft" && ((task.coowned && task.private) || !task.private);
  const handleShare = canShare ? onShare : undefined;
  const interestedIn = task.statistics.watchers_count;

  return (
    <Card>
      <CardTxContent
        task={task}
        type={type}
        isDraft={isDraft}
        isFeed={isFeed}
        numberOfRoles={numberOfRoles}
        isHotVisible={isHotVisible}
        interestedIn={interestedIn}
        handleShare={handleShare}
        handleEditPost={handleEditPost}
        handleHeaderClick={handleHeaderClick}
        handleRefetchActivities={handleRefetchActivities}
      />
    </Card>
  );
};
